module.exports = __webpack_public_path__ + "img/国际经济法.423c6446.png";